import moment from "moment-timezone";
import { BROWSER_TIMEZONE } from "./calendar-utils";

type SchedulerTimezoneNoteProps = {
  date?: Date | string | null;
  label?: string;
  zone?: string | null;
};

export function SchedulerTimezoneNote({
  date,
  label,
  zone,
}: SchedulerTimezoneNoteProps) {
  if (!date) {
    return null;
  }

  const eventZone = zone || BROWSER_TIMEZONE;

  if (eventZone === BROWSER_TIMEZONE) {
    return null;
  }

  return (
    <p className="mt-1 text-xs text-brand-muted">
      {label && <>{label} </>}
      {moment(date).tz(eventZone).format("h:mm A")} {eventZone} &middot;{" "}
      {moment(date).tz(BROWSER_TIMEZONE).format("h:mm A")} your time
    </p>
  );
}
